import {object, SchemaOf, string} from 'yup';

import {VehiclePhotoRequestBody} from '../types/VehiclePhotoRequestBody';

export const $VehiclePhotoRequestBody: SchemaOf<VehiclePhotoRequestBody> = object().shape({
  fileId: string().required(),
});
